  document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.getElementById("megaMenuToggle");
    const drawer = document.getElementById("megaMenuDrawer");
    const backdrop = document.getElementById("megaMenuBackdrop");
    const close = document.getElementById("megaMenuClose");
    let panelHistory = [];

    function showPanel(panelName) {
      drawer.querySelectorAll(".mega-menu__panel").forEach(panel => panel.classList.remove("active"));
      const target = drawer.querySelector(`[data-panel="${panelName}"]`);
      if (target) {
        target.classList.add("active");
        drawer.scrollTop = 0;
      }
    }

    function openMenu() {
      drawer.classList.add("open");
      backdrop.classList.add("active");
      document.body.classList.add("no-scroll");
      panelHistory = [];
      showPanel("main");
      document.getElementById("shopify-chat").style.display = "none";
      currentSlide = 0;
      showSlide(currentSlide);
      startSlider();
    }

    function closeMenu() {
      drawer.classList.remove("open");
      backdrop.classList.remove("active");
      document.body.classList.remove("no-scroll");
      panelHistory = [];
      stopSlider();
      showPanel("main");
      document.getElementById("shopify-chat").style.display = "";
    }

    toggle.addEventListener("click", openMenu);
    close.addEventListener("click", closeMenu);
    backdrop.addEventListener("click", closeMenu);

    function handleForwardNav(targetPanel) {
      const current = drawer.querySelector(".mega-menu__panel.active");
      if (current) {
        const currentPanelName = current.getAttribute("data-panel");
        panelHistory.push(currentPanelName);
        current.classList.remove("active");
      }
      showPanel(targetPanel);
    }

    drawer.querySelectorAll(".mega-menu__back").forEach(back => {
      back.addEventListener("click", () => {
        const previous = panelHistory.pop();
        if (previous) {
          showPanel(previous);
        } else {
          showPanel("main");
        }
      });
    });

    drawer.querySelectorAll(".mega-menu__tile-link").forEach(btn => {
      btn.addEventListener("click", function () {
        const targetPanel = this.getAttribute("data-target");
        handleForwardNav(targetPanel);
      });
    });

    document.querySelectorAll(".has-children").forEach(btn => {
      btn.addEventListener("click", function () {
        const targetPanel = this.getAttribute("data-target");
        handleForwardNav(targetPanel);
      });
    });

    const wrapper = document.querySelector(".mega-menu__slides-wrapper");
    const slides = document.querySelectorAll(".mega-menu__mobile-slide");
    const dots = document.querySelectorAll(".mega-menu__slider-dots .dot");
    let currentSlide = 0;
    let sliderInterval = null;

    function showSlide(index) {
      if (!wrapper || slides.length === 0) return;
      wrapper.style.transform = `translateX(-${index * 100}%)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
      });
    }

    function startSlider() {
      if (slides.length <= 1) return;
      showSlide(currentSlide);
      sliderInterval = setInterval(() => {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
      }, 5000);
    }
    
    document.querySelectorAll('.mega-menu img[loading="lazy"]').forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', () => {
          img.classList.add('loaded');
        });
      }
    });

    function stopSlider() {
      clearInterval(sliderInterval);
      sliderInterval = null;
    }
  });